import { Component } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';

@Component({
  selector: 'hygiene-check-country-editor',
  templateUrl: './hygiene-check-country-editor.component.html',
  styleUrls: ['./hygiene-check-country-editor.component.css']
})
export class HygieneCheckCountryEditorComponent {
  constructor(
    public layoutService: PHBHPLayoutPackageService,
  ) { }
}
